"use strict";

const i18n = require('i18next');
require('bootstrap');
require('backbone.stickit');
const Mn = require('backbone.marionette');
const BlobApiFactory = require('common/infra/api/blob-factory');
const MarkdownWriterView = require('common/ui/view/markdown/writer');
const Snackbar = require('common/util/snackbar');
const Logger = require('common/util/logger');
const IdeaCreateService = require('feedback/app/service/idea/create');
const Idea = require('feedback/domain/entity/idea');
const Template = require('feedback/ui/template/modal/idea.hbs');

module.exports = Mn.View.extend({
    model: Idea,
    template: Template,
    ui: {
        public: '.public'
    },
    bindings: {
        'input.title': 'title',
        'input.body': 'body'
    },

    initialize: function() {
        this.model = new Idea();

        _.bindAll(this, 'setting', 'success', 'error', 'clearValidationErrorMessage');
    },

    clearValidationErrorMessage: function() {
        this.$('div.form-group.title').removeClass('has-error');
        this.$('div.form-group.title .alert-message').html('');
        this.$('div.form-group.body').removeClass('has-error');
        this.$('div.form-group.body .alert-message').html('');
    },

    onRender: function() {
        const json = this.model.toJSON();
        this.$el.html($(Template(json)));

        this.$writer = new MarkdownWriterView({
            markdown: this.model.get('body'),
            useUploader: true,
            useBlobSelector: true,
            blobApi: BlobApiFactory.buildUser()
        });
        this.$('.body .input').append(this.$writer.render().$el);

        this.listenTo(this.$writer, 'change', function(desc){
            this.model.set('body', desc);
            this.uploadable();
        });

        this.listenTo(this.model, 'change:title', function(){
            this.uploadable();
        });

        this.listenTo(this.model, 'validated:invalid', function(model, errors) {
            this.clearValidationErrorMessage();
            _.each(errors, function(e, key) {
                this.$('div.form-group.' + key).addClass('has-error');
                this.$('div.form-group.' + key + ' .alert-message').html(i18n.t(e));
            });
        });
        this.$public = this.$('input.public');

        this.stickit();

        return this;
    },

    setting: function() {
        return new Promise((resolve, reject) => {
            if(!this.model.isValid(true)) {
                return false;
            }

            let referrer = '';
            if (window && window.location && window.location.href) {
                referrer = window.location.href;
            }

            (new IdeaCreateService(
                this.model.getTitle(),
                this.model.getBody(),
                referrer,
                this.isPublic()
            )).execute()
                .then(() => {
                    this.success();
                    resolve();
                }, (xhr) => {
                    this.error(this.model, xhr);
                    reject();
                });
        });
    },

    isPublic: function() {
        return this.$public.is(':checked');
    },

    uploadable: function () {
        if(this.model.get('title') && this.model.get('body')) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },

    success: function() {
        Snackbar.success(i18n.t('notify.user_request.save.success'));
    },

    error: function(model, xhr) {
        Logger.error('error', xhr);
    }
});



// WEBPACK FOOTER //
// ./feedback/ui/view/modal/idea.js